import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 15.8337H17.5V17.5003H2.5V15.8337ZM10.8333 10.9767L15.8926 5.91741L17.0711 7.09593L10 14.167L2.92893 7.09593L4.10744 5.91741L9.16667 10.9767V1.66699H10.8333V10.9767Z",
		fill: "currentColor"
	})
});
export default SvgDownload;
